export default [{
    "id": 0,
    "hot": 1,
    "productId": 0,
    "sortOrder": 0,
    "productUrl": "/static/images/home-mall.png",
    "productImageBig": "/static/images/home-mall.png",
    "productName": "Rebloo 睿勃雅",
    "subTitle": "专属定制隐形正畸矫治",
    "salePrice": 49,
    "detail": "<img src=\"https://resource.smartisan.com/resource/f6de19257228641b1a0c1964239b19b7.jpg\" style=\"width:1110px;height:9970px;\" alt=\"\" />",
    "productImageSmall": ["https://resource.smartisan.com/resource/406eddef8808fa5a9be9594d07ef8643.jpg",
      "https://resource.smartisan.com/resource/548de41c48d47232b4ed541c1df57c2f.jpg",
      "https://resource.smartisan.com/resource/aee0949bc33654bc18cedb8cd7dfbcff.jpg",
      "https://resource.smartisan.com/resource/548de41c48d47232b4ed541c1df57c2f.jpg"
    ]
  },
  {
    "id": 1,
    "hot": 0,
    "productId": 1,
    "sortOrder": 1,
    "productUrl": "/static/images/goods1.png",
    "productImageBig": "/static/images/goods1.png",
    "productName": "可切削基台柱及螺钉",
    "subTitle": "【迈尔医疗】国械注准20223171359",
    "salePrice": 49,
    "detail": "<img src=\"https://yxzrz.oss-cn-beijing.aliyuncs.com/Public/files/goods11detail.png\" style=\"width:1220px;\"/>",
    "productImageSmall": ["https://resource.smartisan.com/resource/406eddef8808fa5a9be9594d07ef8643.jpg",
      "https://resource.smartisan.com/resource/548de41c48d47232b4ed541c1df57c2f.jpg",
      "https://resource.smartisan.com/resource/aee0949bc33654bc18cedb8cd7dfbcff.jpg",
      "https://resource.smartisan.com/resource/548de41c48d47232b4ed541c1df57c2f.jpg"
    ]
  },
  {
    "id": 2,
    "hot": 0,
    "productId": 2,
    "sortOrder": 1,
    "productUrl": "/static/images/goods2.jpeg",
    "productImageBig": "/static/images/goods2.jpeg",
    "productName": "Rebloo 睿勃雅",
    "subTitle": "专属定制隐形正畸矫治",
    "salePrice": 49,
    "detail": "<div style=\"text-align:center;\"><img src=\"https://yxzrz.oss-cn-beijing.aliyuncs.com/Public/files/goodsDetail2.jpeg\" style=\"width:1220px;\"/></div>",
    "productImageSmall": ["https://resource.smartisan.com/resource/406eddef8808fa5a9be9594d07ef8643.jpg",
      "https://resource.smartisan.com/resource/548de41c48d47232b4ed541c1df57c2f.jpg",
      "https://resource.smartisan.com/resource/aee0949bc33654bc18cedb8cd7dfbcff.jpg",
      "https://resource.smartisan.com/resource/548de41c48d47232b4ed541c1df57c2f.jpg"
    ]
  }
]



// WEBPACK FOOTER //
// ./src/assets/config/goodsList.js